export default function getEntityLocalID(
	key: "fund" | "shareclass" | "profile" | "listing",
	id: string | number,
) {
	return `${key}-${id}`;
}
